<script lang="ts">
  
  import { currentBook } from '../stores/reader';
  import Logo from './icons/Logo.svelte';
  import { route } from '@mateothegreat/svelte5-router';
  import ThemeToggle from './ThemeToggle.svelte';

  let currentPath = $state('/');
  let book = $state<typeof $currentBook>(null);

  $effect(() => {
    const updateRoute = () => {
      currentPath = window.location.pathname + window.location.search + window.location.hash.replace(/^#\/?/, '/');
    };
    updateRoute();
    window.addEventListener('pushState', updateRoute);
    window.addEventListener('replaceState', updateRoute);
    window.addEventListener('popstate', updateRoute);
    window.addEventListener('hashchange', updateRoute);
    return () => {
      window.removeEventListener('pushState', updateRoute);
      window.removeEventListener('replaceState', updateRoute);
      window.removeEventListener('popstate', updateRoute);
      window.removeEventListener('hashchange', updateRoute);
    };
  });

  $effect(() => {
    const unsubscribe = currentBook.subscribe(value => {
      book = value;
    });

    return () => unsubscribe();
  });
</script>

<!-- Desktop Header - только для десктопа -->
<header class="h-12 bg-white dark:bg-gray-800 border-b dark:border-gray-700 flex-shrink-0">
  <div class="h-full flex items-center justify-between px-6">
    <!-- Left: Logo and Title -->
    <div class="flex items-center space-x-4">
      <a href="/" use:route class="flex items-center space-x-2">
        <Logo />
        <span class="text-xl font-bold text-gray-900 dark:text-gray-100">Legere</span>
      </a>

      <!-- Current page title -->
      <span class="text-gray-400 dark:text-gray-600">|</span>
      <span class="text-sm text-gray-600 dark:text-gray-400">
        {#if currentPath === '/'}
          Home
        {:else if currentPath.startsWith('/reader')}
          {#if book}
            <span class="text-gray-500 dark:text-gray-500">{book.metadata.author || 'Unknown Author'}</span>
            <span class="mx-1">/</span>
            <span class="font-medium text-gray-700 dark:text-gray-300">{book.title}</span>
          {:else}
            Reader
          {/if}
        {:else if currentPath === '/settings'}
          Settings
        {:else if currentPath === '/profile'}
          Profile
        {:else}
          Data | Blog | ...
        {/if}
      </span>
    </div>

    <!-- Right: Actions -->
    <div class="flex items-center space-x-4">
      <!-- Language switcher -->
      <button class="px-3 py-1 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100">
        EN
      </button>

      <!-- Theme toggle -->
      <ThemeToggle />

      <!-- User profile -->
      <button class="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700" aria-label="User profile">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      </button>
    </div>
  </div>
</header>
